import { Navigate, useLoaderData, useLocation } from 'react-router';

import { ROUTE_SUPPLIERS_DASHBOARD } from '@/constants/router';
import { useUserStore } from '@/store/userStore';

import { homeLoader } from './loader';

interface NavState {
  location?: Location;
}

export const Home = () => {
  const isAuthenticated = useLoaderData<typeof homeLoader>();
  const isAdmin = useUserStore((state) => state.isAdmin);

  const { state }: { state: NavState } = useLocation();
  const supplierId = useUserStore((state) => state.supplierId);

  if (isAuthenticated) {
    if (isAdmin) {
      window.location.href = import.meta.env.VITE_PLATFORM_WEB_URL;
      return null;
    }

    return <Navigate to={state?.location ?? ROUTE_SUPPLIERS_DASHBOARD(supplierId)} />;
  }
  return null;
};
